import { render, staticRenderFns } from "./menuAll.vue?vue&type=template&id=3406e30a&scoped=true&"
import script from "./menuAll.vue?vue&type=script&lang=js&"
export * from "./menuAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406e30a",
  null
  
)

export default component.exports